import config from './config.json'
import { emitter } from './emitter'

export default {
  config: {
    ...config,
  },
  get eventid() {
    return {
      eur: '100000161',
      ea: '100000160',
      sea: '100000159',
    }[window.queryObj.area as NonNullable<Window['queryObj']['area']>]
  },
  get emitter() {
    return emitter
  },
}
